<article class="cm-card" [attr.data-category]="material.category">
  <div class="cm-card__icon"
       [style.background]="visual.bg"
       [style.color]="visual.color">
    <i [class]="visual.icon"></i>
  </div>

  <div class="cm-card__main">
    <header class="cm-card__head">
      <h4 class="cm-card__title">{{ material.title }}</h4>
      <span class="cm-card__pill" [style.color]="visual.color" [style.background]="visual.bg">
        {{ ('LIBRARY.CATEGORY.' + material.category) | translate }}
      </span>

      <!-- Statut de diffusion : sans lui, un support depose et jamais publie
           est indiscernable d'un support en ligne depuis un mois. -->
      <span class="cm-card__status" [attr.data-status]="status">
        <i [class]="statusIcon"></i>
        {{ statusLabelKey | translate }}
      </span>
    </header>

    <p class="cm-card__desc" *ngIf="material.description">{{ material.description }}</p>

    <ul class="cm-card__meta">
      <li *ngIf="material.subjectName">
        <i class="fa-solid fa-book"></i>
        {{ material.subjectName }}
      </li>
      <li *ngIf="material.themeTitle">
        <i class="fa-solid fa-bookmark"></i>
        {{ material.themeTitle }}
      </li>
      <li *ngIf="material.professorFullName">
        <i class="fa-solid fa-chalkboard-user"></i>
        {{ material.professorFullName }}
      </li>
      <li *ngIf="sizeLabel">
        <i class="fa-solid fa-database"></i>
        {{ sizeLabel }}
      </li>
    </ul>
  </div>

  <div class="cm-card__actions">
    <button *ngIf="showFavorite" class="cm-card__fav"
            type="button"
            [class.is-fav]="isFavorite"
            [attr.aria-label]="(isFavorite ? 'FAVORITES.UNFAVORITE' : 'FAVORITES.FAVORITE') | translate"
            (click)="favoriteToggled.emit(!isFavorite)">
      <i [class]="isFavorite ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
    </button>

    <!-- Aperçu proposé seulement pour ce qui s'affiche vraiment : un tableur
         ouvert dans un cadre ne montrerait rien d'utile. -->
    <button *ngIf="canPreview" class="cm-card__action cm-card__action--ghost"
            type="button" (click)="preview.emit(material)">
      <i class="fa-solid fa-eye"></i>
      {{ 'LIBRARY.PREVIEW.ACTION' | translate }}
    </button>

    <button class="cm-card__action" type="button" (click)="onAction()"
            [class.cm-card__action--external]="isExternal">
      <i [class]="isExternal ? 'fa-solid fa-arrow-up-right-from-square' : 'fa-solid fa-download'"></i>
      {{ (isExternal ? 'LIBRARY.OPEN_EXTERNAL' : 'LIBRARY.DOWNLOAD') | translate }}
    </button>
  </div>
</article>
